(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('CptSearch', CptSearch);

    CptSearch.$inject = ['$resource'];

    function CptSearch($resource) {
        var resourceUrl =  'api/_search/cpts/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
